import { StoryFn } from '@storybook/react';

export const WithModalRootDecorator = (Story: StoryFn) => (
  <>
    <Story />
    <div id="modal-root" />
  </>
);
